/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_DeletingInputs */

const he_common_deleting = /** @type {(inputs: Common_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מוחק...`)
};

const en_common_deleting = /** @type {(inputs: Common_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting...`)
};

/**
* | output |
* | --- |
* | "Deleting..." |
*
* @param {Common_DeletingInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const common_deleting = /** @type {((inputs?: Common_DeletingInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_DeletingInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_deleting(inputs)
	return en_common_deleting(inputs)
});